import { Typography } from '@material-ui/core';
import Deprecated from '../core/Deprecated';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SearchDropDown from '../core/SearchDropDown';
import { computeOntologyIRIoptions } from '../core/utils/utils';

class ResourceSearch extends Component {

  render() {

    const { defaultLang, onFoundResource, graph, searchClass, title } = this.props;
    let baseIRI = computeOntologyIRIoptions(this.props.ontologyIRI);

    return (
      <SearchDropDown
        dataTest="resource-search"
        search={(value, lang) => {
          return {
            search: [{
              predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
              value: searchClass
            },
            {
              predicate: [
                "http://www.w3.org/2000/01/rdf-schema#isDefinedBy",
                "https://grafsync.graphifi.com/schema/gs/visibility"
              ],
              value: baseIRI,
              partial: true,
            },
            {
              predicate: "http://www.w3.org/2000/01/rdf-schema#label",
              value: value,
              isExactMatch: false
            }],
            graph: [graph],
            language: lang,
            predicates: [
              "http://www.w3.org/2000/01/rdf-schema#label",
              "http://www.w3.org/2002/07/owl#deprecated"
            ]
          };
        }}
        sortProp="label"
        suppressMessages={true}
        listSecondIcon={(result) => {
          if (result.deprecated) return <Deprecated />;
          return null;
        }}
        listSelectionDisplay={(result, lang) => {
          if (result.label && result.label[lang]) {
            return result.label[lang];
          }
          else return result.id;
        }}
        listDisplay={(result, lang) => <div data-test="result-label">
          <Typography variant="body2">
            {result.label[lang] ?
              result.label[lang]
              :
              result.id
            }
          </Typography>
        </div>
        }
        title={title || "Find a resource"}
        lang={defaultLang}
        chosen={onFoundResource} />
    );
  }

}

ResourceSearch.propTypes = {
  searchClass: PropTypes.string.isRequired,
  graph: PropTypes.string.isRequired,
  ontologyIRI: PropTypes.string.isRequired,
  title: PropTypes.string,
  onFoundResource: PropTypes.func.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default ResourceSearch;